module.exports = __webpack_public_path__ + "img/bolsaimovel.57cac7aa.svg";